export const FETCH_SHIPMENT_LABEL_FILE_SUCCESS = "FETCH_SHIPMENT_LABEL_FILE_SUCCESS";
export const FETCH_SHIPMENT_LABEL_FILE_REQUEST = "FETCH_SHIPMENT_LABEL_FILE_REQUEST";
export const FETCH_SHIPMENT_LABEL_FILE_FAILURE = "FETCH_SHIPMENT_LABEL_FILE_FAILURE";
export const FETCH_SHIPMENT_LABEL_FILE_REST = "FETCH_SHIPMENT_LABEL_FILE_REST";
export const fetchShipmentLabelSuccess = (payload) => ({
    type: FETCH_SHIPMENT_LABEL_FILE_SUCCESS,
    payload,
});
export const fetchShipmentLabelRequest = (payload) => ({
    type: FETCH_SHIPMENT_LABEL_FILE_REQUEST,
    payload,
});
export const fetchShipmentLabelFailure = (payload) => ({
    type: FETCH_SHIPMENT_LABEL_FILE_FAILURE,
    payload,
});
export const fetchShipmentLabelReset = () => ({
    type: FETCH_SHIPMENT_LABEL_FILE_REST,
});
